
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { GetApiUrl } from '@/constants/config';
import { myAcademySlug } from '@/lib/services/academyService';
import { getAuthToken } from '@/lib/services/instance';

window.Pusher = Pusher;

let echoInstance = null;

export function getEcho() {
    if (typeof window === 'undefined') {
        return null;
    }

    if (!echoInstance) {
        const API_URL = GetApiUrl();

        echoInstance = new Echo({
            broadcaster: 'reverb',

            key: process.env.REACT_APP_REVERB_APP_KEY,

            wsHost: process.env.REACT_APP_REVERB_HOST,
            wsPort: Number(process.env.REACT_APP_REVERB_PORT || 8080),
            wssPort: Number(process.env.REACT_APP_REVERB_PORT || 8080),

            forceTLS: process.env.REACT_APP_REVERB_SCHEME === 'https',

            enabledTransports: ['ws', 'wss'],

            authEndpoint: `${API_URL}/api/broadcasting/auth`,

            auth: {
                headers: {
                    Accept: 'application/json',
                    Authorization: getAuthToken(),
                    'X-Academy': myAcademySlug(),
                },
            },
        });
    }

    return echoInstance;
}

export function disconnectEcho() {
    if (echoInstance) {
        echoInstance.disconnect();
        echoInstance = null;
    }
}
